module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Cowbar_C.5c562fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Melee/Item_Weapon_Cowbar_C.png
// module id = ./src/assets/item/Weapon/Melee/Item_Weapon_Cowbar_C.png
// module chunks = 0